import { store } from '@/store/store'
import { Module } from 'vuex'
import { RootStoreState } from '@/store/root/root-store.model'

export class VtStore<T> {
    private readonly _moduleName: string
    private readonly _module: Module<T, RootStoreState>

    /**
     * workaround:
     * created hooks fired before destroyed in hot reload
     * see https://github.com/vuejs/vue/issues/6518
     */
    private _instanceCount: number

    constructor(moduleName: string, module: Module<T, RootStoreState>) {
        this._moduleName = moduleName
        this._module = module

        this._instanceCount = 0
    }

    register() {
        if (++this._instanceCount > 1) return

        if (!store.hasModule(this._moduleName)) {
            store.registerModule<T>(this._moduleName, this._module)
        }
    }

    unregister() {
        if (--this._instanceCount > 0) return
        if (store.hasModule(this._moduleName)) {
            store.unregisterModule(this._moduleName)
        }
    }
}
